import { useSecureGraphqlQuery } from '@psyomics/ui-common';
import { useEffect } from 'react';

import { GetServiceUserInvitesDocument, GetServiceUserInvitesQuery } from '../generated/invites';

const useServiceUserInvites = () => {
  const [response, executeQuery] = useSecureGraphqlQuery<GetServiceUserInvitesQuery>({
    query: GetServiceUserInvitesDocument,
  });

  useEffect(() => {
    executeQuery();
  }, [executeQuery]);

  return response;
};

export { useServiceUserInvites };
